import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const ProblemInternalTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { logs } = useAppSelector(
    (state) => state.customersProblemTransactions.internal,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { getInternalLogsAction, isLoadingLog } = useProblemInternalTransaction(
    {
      transactionId,
    },
  );

  useEffect(() => {
    if (!logs && transactionId) {
      getInternalLogsAction();
    }
  }, [getInternalLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoadingLog}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_INTERNAL_LIST,
      )}
    />
  );
};

export default ProblemInternalTransactionLogContentHOC;
